export const containsStep = <TType extends string>(step: TType, steps: string[]): boolean => {
	return steps.indexOf(step) > -1;
};
